import { render } from "./PraticaAttivazionePreposato.vue?vue&type=template&id=19078ffd&scoped=true"
import script from "./PraticaAttivazionePreposato.vue?vue&type=script&lang=js"
export * from "./PraticaAttivazionePreposato.vue?vue&type=script&lang=js"

import "./PraticaAttivazionePreposato.vue?vue&type=style&index=0&id=19078ffd&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19078ffd"]])

export default __exports__